const ADD_TASK = "addTask"
const TOGGLE_TASK = "toggleTaskCompleted"
const REMOVE_TASK = "removeTask"
const EDIT_TASK = "edditTask"

export {
    ADD_TASK,
    TOGGLE_TASK,
    REMOVE_TASK,
    EDIT_TASK
}